'use client' // Error components must be Client Components

import Button from '@/components/Button'
import CarecoinsBreadcrumbs from '@/components/global/breadcrumbs'
import { useEffect } from 'react'

export default function Error({ error, reset }: {error: {digest: string}, reset: () => void}) {
    useEffect(() => {
        console.error(error)
    }, [error])

    return (
        <>
            <CarecoinsBreadcrumbs />
            <section className="text-left lg:text-center py-6 lg:py-12">
                <div className="container max-w-5xl mx-auto flex justify-center flex-col text-center">
                    <h1 className="text-5xl lg:text-6xl font-bold mb-5">Something went wrong!</h1>
                    <div className="text-xl">
                        Error code: {error.digest}
                    </div>
                    <div
                        className="flex justify-center mt-10"
                        onClick={
                            () => reset()
                        }
                    >
                        <Button label="Try again" class="text-white" />
                    </div>
                </div>
            </section>
        </>
    )
}
